module.exports = new __parcel__URL__("shop_common_resource_box_image.a37eec04.png").toString();